export const BookEditExplanations =
{
    header:
    <div>
        <p>
            A "book" can literally be an entire book that you got from Project Gutenberg, or it might be a short article.
            It can be plain text, but you can also switch to the HTML editor by checking "Use Rich Text Editor".
        </p>
        
        <p>
            As you complete each step, click the "Next" button, and the next set of fields
            will appear.
        </p>
    </div>,
    collapse_single_newlines: <>This can be useful if you copy text from a page/file that puts a newline every X characters.</>,
    non_text_elements:
    <>
        Comma-separated list of HTML elements that don't contain text, like images. They will still be included in the Read view, with their HTML rendered as-is. <i>You can actually use CSS selectors here, too, if the need arises.</i>
    </>,
    skipped_elements:
    <>
        Comma-separated list of elements that should be completely excluded from Read view, such as input fields. <i>You can actually use CSS selectors here, too, if the need arises.</i>
    </>,
    page_size: "When you read the book, it will be split into pages for faster loading. Each page has this many sentences and (if applicable) non-text elements.",
    lang_order:
    <>
        The order in which the languages appear in each sentence in the Read view.
        <br/>
        You can use the arrows, but you can also use drag and drop.
    </>,
    set_default_abbreviations: "Adds abbreviations that you defined on the Abbreviations page to the list for this book.",
};